/**
 * Navigation Component
 *
 * Shared navigation bar memoized for performance
 */

import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { AccountSwitcher } from './AccountSwitcher'

interface NavigationProps {
  className?: string
}

export const Navigation: React.FC<NavigationProps> = React.memo(({ className = '' }) => {
  const { user, logout } = useAuth()

  return (
    <nav className={`bg-dark-800 border-b border-dark-600 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-8">
            <h1 className="text-xl font-bold text-neon-blue">The Bag</h1>
            <Link
              to="/dashboard"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Dashboard
            </Link>
            <Link
              to="/charts"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Charts
            </Link>
            <Link
              to="/backtesting"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Backtesting
            </Link>
            <Link
              to="/downloads"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Downloads
            </Link>
            <Link
              to="/instruments"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Instruments
            </Link>
            <Link
              to="/instrument-lists"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Lists
            </Link>
            <Link
              to="/strategies"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Strategies
            </Link>
            <Link
              to="/performance"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Performance
            </Link>
            <Link
              to="/investors"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Investors
            </Link>
            <Link
              to="/optimizations"
              className="text-arcade-muted hover:text-neon-blue transition-colors"
            >
              Optimizations
            </Link>
          </div>
          <div className="flex items-center space-x-4">
            <AccountSwitcher />
            <span className="text-sm text-arcade-muted">{user?.username}</span>
            <button onClick={logout} className="btn btn-secondary text-sm">
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  )
})

Navigation.displayName = 'Navigation'
